<template>
  <a-modal
    :title="title"
    :width="870"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template>
      <WangEditor v-model="form.comment" :editorStyle="{ minHeight: '300px' }" />
    </template>
  </a-modal>
</template>

<script>
import WangEditor from '@/components/WangEditor'
import { postAction } from '@api/manage'

export default {
  name: 'CreateSubjectModal',
  components: {
    WangEditor,
  },
  props: {
    title: {
      type: String,
      default: '工作点评',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      currEvalInfo: {},
    }
  },
  methods: {
    showModal(data) {
      console.log('点评数据：', data)
      this.visible = true
      this.currEvalInfo = data
    },
    hideModal() {
      this.visible = false
      this.current = 1
    },
    async handleOk() {
      const params = {
        studentId: this.currEvalInfo.studentId,
        dataType: 9,
        ...this.form,
      }
      console.log('参数信息：', params)
      const res = await postAction('/aigoes/schoolWarnRecord/add', params)
      if (res.success) {
        this.$message.success(res.message)
        this.$emit('refreshData')
      } else {
        this.$message.error(res.message || '保存失败')
      }
      console.log('提交结果：', res)
      this.hideModal()
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less"></style>
